import type React from 'react';

import { BrandShowcase } from './BrandShowcase';

type PageLayoutProps = {
  children: React.ReactNode;
};

export const PageLayout = ({ children }: PageLayoutProps) => {
  return (
    <div className="flex min-h-screen bg-[#F6F6F6]">
      {/* 左侧品牌展示区域 */}
      <BrandShowcase />

      {/* 右侧内容区域 */}
      {children}
    </div>
  );
};
